import { faPodcast } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "bootstrap/dist/css/bootstrap.min.css";
import { stat } from 'fs';
import * as React from 'react';
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { Col, Container, Row } from "reactstrap";
import VideoHotlineDetail from "./videoHotlineDetail";
import VideoHotlineList from "./videoHotlinelList";
import { dashboardListConstants } from '../home';

class VideoHotlinesPageComponent extends React.Component {
	state = {
		isView: false,
		selectedId: false,
		dropdownShopOpen: false,
		page: "",
		id: -1,
		title: "",
		code: "",
	}
	constructor(props: any) {
		super(props);
		this.state = {
			isView: false,
			selectedId: false,
			dropdownShopOpen: false,
			page: "",
			id: -1,
			title: "",
			code: "",
		}
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search))?.get("page");
		var tValue = tokenstr == null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr == null ? -1 : parseInt(idstr);
		var codestr = (new URLSearchParams(window.location.search)).get("code");
		var codeValue = codestr == null ? "" : codestr;
		var pageValue = (id >= 0 || (codeValue && codeValue != '')) ? "detail" : tValue;
		this.setState({
			...stat,
			page: pageValue,
			id: id,
			code: codeValue,
			isView: pageValue == "" ? true : false,
		});
		
		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage != "") {
			store.addNotification({
				title: "Success!",
				message: alertMessage,
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true
				}
			});
			window.localStorage.setItem('alertMessage', "");
		}

		document.title = `${pageValue==="" ? "VideoHotlines" : "VideoHotline"} - Daily Audio Bible Administration`;
	}


	handleCallbackMethod(value) {
		this.setState({ title: value });
	}
	render() {
		const data = JSON.parse(window.localStorage.getItem('dashboardListData') || "[]");
		const videoData = data && data.find((item) => item.uniqueCode === dashboardListConstants.videoHotline);

		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
						{this.state.page == "detail" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="videoHotlineDetailTitle"> {videoData?.title ?? "Video Hotline"} - Details</span>
									</h2>
									<hr />
									<VideoHotlineDetail callback={this.handleCallbackMethod} id={this.state.id} />
								</div>
							)}
							{this.state.page == "" && this.state.isView && (<div>
								<h2>
									<FontAwesomeIcon icon={faPodcast} />
									<span data-testid="videoHotlinePageTitle"> {videoData?.title ?? "Video Hotline"}</span>
								</h2>
								<hr />
								<VideoHotlineList title={videoData?.title} />
							</div>)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default VideoHotlinesPageComponent;